export default "__VITE_ASSET__43619973__"